const o = "styles-module__modal___XxBSH", _ = "styles-module__closing___TiioN", s = "styles-module__modalContent___eFLgk", e = "styles-module__close___f4V3P", l = "styles-module__iframe___M4qvU", n = "styles-module__loadingSpinner___1vhmY", t = "styles-module__spinner___609dl", d = {
  modal: o,
  closing: _,
  modalContent: s,
  close: e,
  iframe: l,
  loadingSpinner: n,
  spinner: t
};
export {
  e as close,
  _ as closing,
  d as default,
  l as iframe,
  n as loadingSpinner,
  o as modal,
  s as modalContent,
  t as spinner
};
